module.exports = __webpack_public_path__ + "img/logo.7316a41a.png";